export default function FormLabel(theme) {
  return {
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: theme.palette.grey[500],
          '&.Mui-focused': {
            color: theme.palette.grey[500]
          }
        }
      }
    }
  };
}
